import React from "react";

export const CatholicDoctrine = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={size}
            height={size}
            viewBox="0 0 682.66669 682.66669"
            {...props}
        >
            <defs>
                <clipPath clipPathUnits="userSpaceOnUse" id="a">
                    <path d="M0 512h512V0H0z" />
                </clipPath>
            </defs>
            <path
                d="M431.131 30.905H80.869v450.189h350.262z"
                fill="#94e8c8"
                fillOpacity={1}
                fillRule="nonzero"
                stroke="none"
                transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
            />
            <g clipPath="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
                <path
                    d="M0 0c-142.879 27.392-251.303 151.695-254.209 301.867h-96.053v-450.19H0z"
                    fill="#06ccab"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(431.13 179.228)"
                />
                <path
                    d="M389.924 30.905H122.077v450.189h267.847z"
                    fill="#ff583e"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                />
                <path
                    d="M0 0c-122.042 41.3-210.382 155.664-213.002 291.026h-54.845v-450.189H0z"
                    fill="#f92814"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(389.924 190.069)"
                />
                <path
                    d="M0 0l-44.158-14.719c-8.053-2.685-15.715 4.977-13.031 13.031l14.72 44.157c2.223 6.671-2.742 13.56-9.774 13.56h-53.828c-7.032 0-11.997-6.889-9.773-13.56l14.719-44.157c2.685-8.054-4.977-15.716-13.031-13.031L-158.314 0c-6.67 2.224-13.559-2.742-13.559-9.773v-53.829c0-7.031 6.889-11.996 13.559-9.773l44.158 14.719c8.054 2.685 15.716-4.977 13.031-13.03l-14.719-44.158c-2.224-6.671 2.741-13.56 9.773-13.56h53.828c7.032 0 11.997 6.889 9.774 13.56l-14.72 44.158c-2.684 8.053 4.978 15.715 13.031 13.03L0-73.375c6.671-2.223 13.56 2.742 13.56 9.773v53.829C13.56-2.742 6.671 2.224 0 0"
                    fill="#fff8ab"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(335.157 352.953)"
                />
                <path
                    d="M0 0h-26.914c-7.032 0-11.997-6.889-9.773-13.56l14.719-44.157c2.684-8.054-4.977-15.716-13.031-13.031l-44.158 14.719c-6.67 2.224-13.559-2.741-13.559-9.773v-26.914h72.112C-9.225-92.716 0-83.492 0-72.113z"
                    fill="#ffee6e"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(256 408.982)"
                />
                <path
                    d="M0 0h26.914c7.032 0 11.997 6.889 9.773 13.56L21.968 57.717c-2.684 8.054 4.977 15.716 13.031 13.031l44.158-14.719c6.67-2.224 13.559 2.741 13.559 9.773v26.914H20.604C9.225 92.716 0 83.492 0 72.113z"
                    fill="#ffee6e"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(256 223.55)"
                />
                <path
                    d="M0 0c0-17.069-13.837-30.905-30.905-30.905-17.069 0-30.906 13.836-30.906 30.905 0 17.069 13.837 30.905 30.906 30.905C-13.837 30.905 0 17.069 0 0"
                    fill="#e9edf5"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(512 481.094)"
                />
                <path
                    d="M0 0c-17.069 0-30.905 13.837-30.905 30.905 0 2.88.402 5.664 1.138 8.309-13.031-3.631-22.597-15.578-22.597-29.767 0-17.069 13.837-30.905 30.906-30.905 14.189 0 26.136 9.565 29.766 22.597A30.896 30.896 0 000 0"
                    fill="#cdd2e1"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(502.553 471.648)"
                />
                <path
                    d="M0 0c0-17.069-13.837-30.905-30.905-30.905-17.069 0-30.906 13.836-30.906 30.905 0 17.069 13.837 30.905 30.906 30.905C-13.837 30.905 0 17.069 0 0"
                    fill="#e9edf5"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(61.81 481.094)"
                />
                <path
                    d="M0 0c-17.069 0-30.905 13.837-30.905 30.905 0 2.88.402 5.664 1.138 8.309-13.031-3.631-22.597-15.578-22.597-29.767 0-17.069 13.837-30.905 30.905-30.905 14.19 0 26.137 9.565 29.767 22.597A30.896 30.896 0 000 0"
                    fill="#cdd2e1"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(52.364 471.648)"
                />
                <path
                    d="M0 0h-350.262c-17.068 0-30.905 13.837-30.905 30.905 0 17.069 13.837 30.906 30.905 30.906H0c17.069 0 30.905-13.837 30.905-30.906C30.905 13.837 17.069 0 0 0"
                    fill="#ff8870"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(431.13 450.19)"
                />
                <path
                    d="M0 0c0 17.069 13.837 30.905 30.905 30.905H-82.414c-17.069 0-30.906-13.836-30.906-30.905 0-17.069 13.837-30.905 30.906-30.905H30.905C13.837-30.905 0-17.069 0 0"
                    fill="#ff583e"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(163.284 481.094)"
                />
                <path
                    d="M0 0c0-17.069-13.837-30.905-30.905-30.905-17.069 0-30.906 13.836-30.906 30.905 0 17.069 13.837 30.905 30.906 30.905C-13.837 30.905 0 17.069 0 0"
                    fill="#e9edf5"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(512 30.905)"
                />
                <path
                    d="M0 0c-17.069 0-30.905 13.837-30.905 30.905 0 2.88.402 5.664 1.138 8.309-13.031-3.63-22.597-15.578-22.597-29.767 0-17.069 13.837-30.905 30.906-30.905 14.189 0 26.136 9.565 29.766 22.597A30.896 30.896 0 000 0"
                    fill="#cdd2e1"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(502.553 21.459)"
                />
                <path
                    d="M0 0c0-17.069-13.837-30.905-30.905-30.905-17.069 0-30.906 13.836-30.906 30.905 0 17.069 13.837 30.905 30.906 30.905C-13.837 30.905 0 17.069 0 0"
                    fill="#e9edf5"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(61.81 30.905)"
                />
                <path
                    d="M0 0c-17.069 0-30.905 13.837-30.905 30.905 0 2.88.402 5.664 1.138 8.309-13.031-3.63-22.597-15.578-22.597-29.767 0-17.069 13.837-30.905 30.905-30.905 14.19 0 26.137 9.565 29.767 22.597A30.896 30.896 0 000 0"
                    fill="#cdd2e1"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(52.364 21.459)"
                />
                <path
                    d="M0 0h-350.262c-17.068 0-30.905 13.837-30.905 30.905 0 17.069 13.837 30.906 30.905 30.906H0c17.069 0 30.905-13.837 30.905-30.906C30.905 13.837 17.069 0 0 0"
                    fill="#ff8870"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(431.13)"
                />
                <path
                    d="M0 0c0 17.069 13.837 30.905 30.905 30.905H-82.414c-17.069 0-30.906-13.836-30.906-30.905 0-17.069 13.837-30.905 30.906-30.905H30.905C13.837-30.905 0-17.069 0 0"
                    fill="#ff583e"
                    fillOpacity={1}
                    fillRule="nonzero"
                    stroke="none"
                    transform="translate(163.284 30.905)"
                />
                <path
                    d="M0 0h182.342"
                    fill="none"
                    stroke="#c10000"
                    strokeWidth={15}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit={10}
                    strokeDasharray="none"
                    strokeOpacity={1}
                    transform="translate(164.829 173.585)"
                />
                <path
                    d="M0 0h44.813"
                    fill="none"
                    stroke="#c10000"
                    strokeWidth={15}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit={10}
                    strokeDasharray="none"
                    strokeOpacity={1}
                    transform="translate(302.358 111.775)"
                />
                <path
                    d="M0 0h106.623"
                    fill="none"
                    stroke="#c10000"
                    strokeWidth={15}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit={10}
                    strokeDasharray="none"
                    strokeOpacity={1}
                    transform="translate(164.829 111.775)"
                />
            </g>
        </svg>
    );
}

export default CatholicDoctrine;